<p-steps
  [model]="itemList"
  class="mu-steps-breadcrumb"
  [(activeIndex)]="activeIndex"
  [readonly]="readonly"
  [ngClass]="{ 'mu-hide-number': hideNumber }"
></p-steps>
